import { ModuleBase } from './ModuleBase'
import { hall } from '@/hall'
import { base } from '@/base/base'
import { WebDefine } from '@/defines/WebDefine'
import { log } from '@/utils/functions'
import { PopupViews } from '@/defines/EnumDefine'

export class VipDailyCashModule extends ModuleBase {
  public getedDailyCashInfos_ = false
  public dailyCashInfos: any = null
  public paying: any = []

  init(): void {
    this.getedDailyCashInfos_ = false
    this.dailyCashInfos = null
    this.paying = []
  }

  onClear(): void {}

  onLoad(): void {}

  onDestroy(): void {}

  inits2c(): void {}

  onPreloadData(): void {
    log('VipDailyCashModule onPreloadData')
    //this.requestDailCashInfos()
  }

  //获取vip每日奖励信息
  requestDailCashInfos() {
    const data = {
      cid: base.channelId,
      uid: hall.userModule.userId,
    }
    base.httpUtil
      .postJson(WebDefine.userVipDailyCashInfo, data)
      .then((respJson: any) => {
        if (respJson && respJson.code == 200) {
          this.getedDailyCashInfos_ = true
          this.dailyCashInfos = respJson.data
          hall.eventDispatcher.emit(hall.EventDefine.VipDailyCashChange)
          // hall.eventDispatcher.emit(hall.EventDefine.TryAddPopupView, hall.Constants.VipDailyCash)
        } else {
          log('requestDailCashInfos failFun')
        }
      })
      .catch((error: any) => {
        log('error:', error)
      })
  }

  //领取奖励
  getVipDailyCashRewards() {
    const cashInfo = this.getDailyCashInfos()
    if (cashInfo == null) {
      log('getVipDailyCashRewards is nil')
      return
    }
    const data = {
      cid: base.channelId,
      uid: hall.userModule.userId,
    }
    base.httpUtil
      .postJson(WebDefine.userGetDailyCash, data)
      .then((respJson: any) => {
        if (respJson && respJson.code == 200) {
          hall.eventDispatcher.emit(hall.EventDefine.GetVipDailyReward)
          // 领取成功，更新玩家金币
          hall.userModule.sendClient2ProxyReqGetBalance()
          // 拉取 vip每日奖励 信息
          this.requestDailCashInfos()
          hall.eventDispatcher.emit(hall.EventDefine.ChangeBindActivityRed)
        } else {
          log('getVipDailyCashRewards failFun')
        }
      })
      .catch((error: any) => {
        log('error:', error)
      })
  }

  // 有在支付中时，app 返回前台拉取一下 vip每日奖励 信息
  getDailyCashInfosByPaying() {
    this.requestDailCashInfos()
  }

  getDailyCashInfos() {
    return this.dailyCashInfos
  }

  //获取每日可领取金额
  getVipDailyMoney() {
    if (this.dailyCashInfos == null) {
      return 0
    }
    const gold = this.dailyCashInfos['gold']
    const diamond = this.dailyCashInfos['diamond']
    if (gold != 0) {
      return gold
    }
    return diamond
  }

  getVipDailyOver() {
    if (this.dailyCashInfos == null) {
      return false
    }
    return this.dailyCashInfos['time'] == null
  }

  isGetDailyCashInfos() {
    return this.dailyCashInfos != null
  }

  isGetedDailyCashInfos() {
    return this.getedDailyCashInfos_
  }

  isHasDailyCash() {
    if (this.dailyCashInfos == null) {
      return false
    }
    return Object.keys(this.dailyCashInfos).length != 0
  }

  //判断当前今日奖励可以领取？
  canGetRewardNow() {
    if (this.dailyCashInfos == null) {
      return false
    }

    return this.dailyCashInfos['status'] == 1
  }

  getVipDailyTime() {
    if (this.dailyCashInfos == null) {
      return 0
    }
    if (this.dailyCashInfos['time'] == null) {
      return 0
    }
    return this.dailyCashInfos['time']
  }

  // 是否已获取到弹窗判断的数据
  isGetedPopupData() {
    return this.getedDailyCashInfos_
  }

  // 是否需要弹窗
  popupView() {
    // VIP卡领取弹框——每日一次，可领取的时候弹出
    if (this.canGetRewardNow()) {
      hall.popupViewModule.addPopupView(PopupViews.VipRewardPanel)
    }
  }
}
